import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { CustomAlertInterface } from './models/custom-alert-interface.model';

@Component({
  selector: 'app-custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.css']
})
export class CustomAlertComponent implements AfterViewChecked {

  dsAlert?: CustomAlertInterface[];
  private lastCount: number = 0;

  @Input() set dataSource(value: CustomAlertInterface[]) {

    this.dsAlert = value;
    this.lastCount = this.dsAlert.length;
    window.scrollTo(0, 0);
  }

  constructor() { }

  ngAfterViewChecked(): void {

    if (this.dsAlert && this.lastCount < this.dsAlert.length) {

      this.lastCount = this.dsAlert.length;

      window.scrollTo(0, 0);
    }
  }

}
